import { render } from "./TableNoExport.vue?vue&type=template&id=89c6b934&scoped=true"
import script from "./TableNoExport.vue?vue&type=script&lang=js"
export * from "./TableNoExport.vue?vue&type=script&lang=js"

import "./TableNoExport.vue?vue&type=style&index=0&id=89c6b934&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89c6b934"]])

export default __exports__